import React from 'react'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'

import SettingsPage from '../SettingsPage'
import NoPermissionContainer from '@SonarCX/components/molecules/NoPermissionContainer'
import SettingsSection from '../SettingsSection'
import Button from '@SonarCX/components/atoms/Button2'
import TeamsEditModal from './TeamsEditModal'
import TeamsTable from './TeamsTable'
import TeamsCards from './TeamsCards'

import { selectTeams, fetchTeams } from '@SonarCX/slices/teamsSlice'
import { useBreakpoint } from '@SonarCX/providers/BreakpointProvider'
import useStyles from './styles'

const TeamSettings = () => {
  const dispatch = useAppDispatch()
  const { loaded, loading, error } = useAppSelector(selectTeams)

  const { isExtraSmall } = useBreakpoint()

  const [showModal, setShowModal] = React.useState(false)
  const [data, setData] = React.useState(null)

  const classes = useStyles()

  // Loads teams
  React.useEffect(() => {
    if (!loaded && !loading) {
      dispatch(fetchTeams())
    }
  }, [loaded, loading, dispatch])

  // Opens the modal
  const openModal = React.useCallback(
    data => () => {
      if (data) {
        setData(data)
      }
      setShowModal(true)
    },
    []
  )

  const handleClose = React.useCallback(() => {
    setShowModal(false)
    setData(null)
  }, [])

  return (
    <SettingsPage title='Teams'>
      <NoPermissionContainer skipAgentPage error={error}>
        <SettingsSection title='Settings' loaded={loaded}>
          {isExtraSmall ? (
            <TeamsCards openModal={openModal} />
          ) : (
            <TeamsTable openModal={openModal} />
          )}

          <div className={classes.root}>
            <Button
              onClick={() => setShowModal(true)}
              className={classes.button}
            >
              ADD TEAM
            </Button>
          </div>

          {showModal && (
            <TeamsEditModal
              open={showModal}
              onClose={handleClose}
              data={data}
            />
          )}
        </SettingsSection>
      </NoPermissionContainer>
    </SettingsPage>
  )
}

export default TeamSettings
